import type { IconProps, IconSize } from "@/ui/core/Icon/Icon";
import Icon from "@/ui/core/Icon/Icon";
import { FAIconName } from "@/ui/core/Icon/IconDefinitions";

export default Icon;
export type { IconProps, IconSize };
export { FAIconName };
